import { SocketEvent } from "../api/socket";

let audioContext: AudioContext | null = null;

export function isIncomingMessageEvent(event: SocketEvent): boolean {
  return event.type === "chat_updated" && Boolean(event.incoming_message_id);
}

export function shouldPlayNotificationSound(
  event: SocketEvent,
  _selectedChatId: string | null,
  _pageVisible: boolean,
): boolean {
  return isIncomingMessageEvent(event);
}

export function armNotificationSound(): () => void {
  const activate = () => {
    const AudioContextClass =
      window.AudioContext ||
      (window as typeof window & { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!AudioContextClass) return;
    audioContext ||= new AudioContextClass();
    if (audioContext.state === "suspended") void audioContext.resume();
  };
  window.addEventListener("pointerdown", activate, { passive: true });
  window.addEventListener("keydown", activate);
  return () => {
    window.removeEventListener("pointerdown", activate);
    window.removeEventListener("keydown", activate);
  };
}

export function playNotificationSound(): void {
  if (!audioContext || audioContext.state !== "running") return;
  const start = audioContext.currentTime;
  const gain = audioContext.createGain();
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(0.55, start + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.72);
  gain.connect(audioContext.destination);
  [659, 880, 1047].forEach((frequency, index) => {
    const oscillator = audioContext!.createOscillator();
    const toneStart = start + index * 0.14;
    oscillator.type = "triangle";
    oscillator.frequency.setValueAtTime(frequency, toneStart);
    oscillator.connect(gain);
    oscillator.start(toneStart);
    oscillator.stop(toneStart + 0.3);
  });
}
